import { useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';

import { setCreditPurposeInfo, useDictionaries } from 'entities/creditForm';

import { applyFilter } from 'features/VitrinsFilters';

const isStringOrValidNumber = (v: unknown): v is string | number =>
  typeof v === 'string' || (typeof v === 'number' && !Number.isNaN(v));

export const useOnCalculatorFieldChange = () => {
  const dispatch = useAppDispatch();
  const { purposes: purposeOptions, periods: periodOptions } = useDictionaries(['purposes', 'periods']);

  return useCallback(
    (fieldName: string, value: unknown) => {
      switch (fieldName) {
        case 'amount': {
          if (!isStringOrValidNumber(value)) {
            break;
          }

          dispatch(
            setCreditPurposeInfo({
              data: {
                amount: value.toString(),
              },
            }),
          );
          dispatch(applyFilter({ alias: 'amount', value: value.toString() }));
          break;
        }
        case 'purpose':
        case 'period': {
          const optionsMap = {
            purpose: purposeOptions,
            period: periodOptions,
          } as const;

          const key = fieldName as keyof typeof optionsMap;

          const options = (optionsMap[key] ?? []) as Array<{ value: unknown }>;
          const option = options.find((item) => item.value === value);

          if (!option) {
            break;
          }

          dispatch(
            setCreditPurposeInfo({
              data: {
                [fieldName]: option,
              },
            }),
          );
          if (fieldName === 'period' && value && typeof value === 'string') {
            dispatch(applyFilter({ alias: 'period', value }));
          }
          break;
        }
        default:
          break;
      }
    },
    [dispatch, purposeOptions, periodOptions],
  );
};
